import styled from 'styled-components'
import { BLACK, GRAYSCALE_500, LIGHT_YELLOW, NEUTRAL_100, PALE_YELLOW, WHITE } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  padding: 16px;
  background-color: ${WHITE};
`

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: center;
`

export const AmountLabel = styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${GRAYSCALE_500};
`

export const AmountValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`

export const AmountValue = styled.span`
  font-family: ${INTER.bold};
  font-size: 20px;
  color: ${BLACK};
`

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  background-color: ${LIGHT_YELLOW};
  border: 1px solid ${PALE_YELLOW};
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
`

export const LinkText = styled.span`
  max-width: 70%;
  line-height: 1.2em;
  max-height: 2.4em;
  word-break: break-all;
  overflow: hidden;
  display: block;
  color: ${BLACK};
  font-family: ${INTER.medium};
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
`

export const CircularButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #E4E7ED33;
  border-radius: 100%;
  cursor: pointer;
`
